import React from 'react';
import {Button, Glyphicon} from 'react-bootstrap/lib';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';

const offerNew = ({label, history}) => {
  return (
    <div className="offer-new text-center">
      <p>Good news! <b>{label}</b> is not registered yet!</p>
      <p>
        <Button bsSize="large" onClick={() => history.push(`/register?coin=${label}`)}>
          <Glyphicon glyph="ok" style={{marginRight: '10px'}} />
          I want to register it now!
        </Button>
      </p>

    </div>
  );
};

offerNew.propTypes = {
  label: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  })
};
export default withRouter(offerNew);



// WEBPACK FOOTER //
// ./src/home/search/offer-new.js